import { render, staticRenderFns } from "./Coordenador.vue?vue&type=template&id=7a9dd995&"
import script from "./Coordenador.vue?vue&type=script&lang=js&"
export * from "./Coordenador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports